module.exports = __webpack_public_path__ + "static/media/design-within-reach.e91d5ba0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header-photos/design-within-reach.jpg
// module id = 767
// module chunks = 27